// write a redux slice that will store the user data with typescript
// first define the state type
import { createSlice, PayloadAction} from '@reduxjs/toolkit';
import { UserEntitlementData } from './UserEntitlementSlice';
import { defaultEntitlements } from './UserEntitlementSlice';

export interface UserData {
  userType: 'teacher' | 'SCHOOL_ADMIN' | 'DISTRICT_ADMIN';
  userId: string;
  sessionId: string;
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  loading: boolean;
  error: string;
  entitlements: UserEntitlementData;
  [key: string]: any; // allow any other key value pairs
}

// define the initial state
const initialState: UserData = {
  userType: 'teacher',
  userId: '',
  schoolId: '',
  districtId: '',
  sessionId: '',
  firstName: '',
  lastName: '',
  email: '',
  userName: '',
  loading: true,
  error: '',
  entitlements: { ...defaultEntitlements },
};

// create the slice
const UserDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<UserData>) => {
      // delete fields that shouldn't be in the state
      delete action.payload.sessionData;
      
      state = action.payload;
      state.loading = false;
      state.error = '';
      return state;
    },
    setUserDataError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      return state;
    },
    clearUserData: (state) => {
      return initialState;
    },
  },
});

// export the selector
export const selectUserData = (state: { userData: UserData }) => state.userData;

// export the actions
export const { setUserData, clearUserData } = UserDataSlice.actions;

// export the reducer
export default UserDataSlice.reducer;


